module.exports = __webpack_public_path__ + "static/media/axis_of_polarization_00133.36da6747.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/hdpolarized/axis/en/axis_of_polarization_00133.png
// module id = 863
// module chunks = 0